import React, { memo } from 'react';

import { areEqualShallow } from 'Utils/equalityChecks';
import ClockInActive from '../../../Assets/clock-in-active.svg';

// Custom css
import classes from './clockInActive.module.css';

interface Props {
  className?: string;
  id?: string;
  onClick?: (e: any) => void;
  onKeyUp?: (e: any) => void;
}
const ClockInActiveSvg = ({ className = '', id, onClick, onKeyUp }: Props) => (
  <ClockInActive id={id} className={`${classes.iconBase} ${className || ''}`} onClick={onClick} onKeyUp={onKeyUp} />
);

ClockInActiveSvg.defaultProps = {
  className: undefined,
  id: undefined,
  onClick: undefined,
  onKeyUp: undefined,
};

const ClockInActiveSvgMemo = memo(ClockInActiveSvg, areEqualShallow);

export { ClockInActiveSvgMemo as ClockInActiveSvg };
